import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87e27d24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["onDrop"]
const _hoisted_3 = {
  class: "row",
  style: {"min-height":"100px","border":"dotted gray 1px"}
}
const _hoisted_4 = ["onDrop"]

import TicketCard from '@/components/Workspaces/tickets/_spec/TicketCard.vue';
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
import { BoardPosition } from '@/logic/_infra/boards';
import { dragEventRef } from '@/controllers/workspaces/tickets/_spec/ticket.item.controller'
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { ITicketUiElementController } from '@/components/Workspaces/tickets/_spec/ticket.controller.elementary.interface'
import { BlockRmodel } from '@/app.context/workspace/tickets/tasks/block.rmodel';
import TicketSlideup from '@/components/Workspaces/tickets/_spec/TicketSlideUp.vue'
import { ticketItemString } from '@/controllers/workspaces/tickets/_spec/ticket.item.controller'
import { IFileStorage, IWorkspaceStorage } from '@/io/storages';
import { TicketItemModel } from '@/app.context/workspace/tickets/_spec/Ticket.Item.Model';
import * as ticketProcessor from '@/ops/workspaces/ticket.processor'
import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';


export default /*#__PURE__*/_defineComponent({
  __name: 'GridComponent',
  props: {
    matrix: {},
    x4: { type: Boolean },
    level: {},
    circledX: { type: Boolean },
    controller: {},
    focused: {},
    focused_index: {},
    files: {},
    efforts: {}
  },
  emits: {
    add: null,
    'swipe-up': null,
    'swipe-down': null,
    'x': null,
    'v': null,
    'o': null,
    'stop': null,
    'drop': null,
    'click': null,
    'click.right': null,
    'command': null,
    "person"(t: TicketRmodel | TodoRmodel, p: PersonRmodel, index: number | null): boolean {
        // perform runtime validation
        return t != null && p != null
    },
    "block"(b: BlockRmodel): boolean {
        // perform runtime validation
        return b != null
    },
    "popupClosed": null
},
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

function onAdd(column: number, row: number) {

    const p = new BoardPosition()

    p.column = column
    p.row = row

    emit("add", p)
}

function onCloseClick(item: TicketRmodel | TodoRmodel) {

    props.controller?.close(item)

    emit('x', item)
}

function onCheckClick(item: TicketRmodel | TodoRmodel) {

    props.controller?.check(item)

    emit('v', item);
}


function onStopClick(item: TicketRmodel | TodoRmodel) {

    props.controller?.stop(item)

    emit('stop', item);
}

function onResetClick(item: TicketRmodel | TodoRmodel) {

    props.controller?.reset(item)

    emit('o', item);
}

function onPersonClick(item: TicketRmodel | TodoRmodel, person: PersonRmodel, index: number | null) {

    props.controller?.person(item, person, index)

    emit('person', item, person, index);
}

function onBlockClick(item: BlockRmodel) {

    props.controller?.block(item)

    emit('block', item);
}

function onFiles(t: TicketRmodel | TodoRmodel, files: File[]) {

    const s = props.files

    if (s!= null){

        if (t instanceof TodoRmodel) t = t.ticket

        ticketProcessor.addFiles(s, t.workspace.storage, t, files)
    }
 }


function onClick(item: TicketRmodel | TodoRmodel) {

    emit('click', item);
}

function onClickRight(item: TicketRmodel | TodoRmodel) {

    emit('click.right', item);
}

function onCommand(command: string, ticket: TicketRmodel) { emit('command', command, ticket) }

function onSwipeUp(column: number, row: number) {

    const p = new BoardPosition()

    p.column = column
    p.row = row

    emit("swipe-up", p)
}

function onSwipeDown(column: number, row: number) {

    const p = new BoardPosition()

    p.column = column
    p.row = row
    emit("swipe-down", p)
}



function identificator(value: TicketRmodel | TodoRmodel | null): number {

    if (value == null) return 0;

    if (value instanceof TicketRmodel) return value.n;
    if (value instanceof TodoRmodel) return value.task.ticket.n;

    return 0;
}


function ticketOrUndefined(value: TicketRmodel | TodoRmodel | null): TicketRmodel | undefined {

    if (value == null) return undefined;

    if (value instanceof TicketRmodel) return value as TicketRmodel;

    return undefined;
}

function todoOrUndefined(value: TicketRmodel | TodoRmodel | null): TodoRmodel | undefined {

    if (value == null) return undefined;

    if (value instanceof TodoRmodel) return value as TodoRmodel;

    return undefined;
}

function onDrop(e: DragEvent, x: number, y: number) {

    const ref = dragEventRef(e)

    if (ref != null) {

        const p: BoardPosition = new BoardPosition()

        p.column = x
        p.row = y

        emit('drop', ref, p)
    }
}

function onDrageEnter(e: DragEvent) {

}

function onDragLeave(e: DragEvent) {

}

function onDragOver(e: DragEvent) {

    if (props.level >= TicketAccessLevel.Full) {

        e.preventDefault() //allows drop only when level permits
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.matrix, (r, rowKey) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: rowKey }, [
        (props.focused_index == rowKey && props.focused?.ticket != null)
          ? (_openBlock(), _createBlock(TicketSlideup, {
              key: 0,
              model: props.focused,
              files: props.files,
              level: props.level,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('popupClosed')))
            }, null, 8, ["model", "files", "level"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r, (t, cellKey) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["cell", { 'cell-x4': props.x4 ?? false, 'cell-x5': !props.x4 ?? true }]),
              key: t?.key ?? `C${cellKey}`,
              onDragenter: _withModifiers(onDrageEnter, ["prevent"]),
              onDragleave: onDragLeave,
              onDragover: onDragOver,
              onDrop: ($event: any) => (onDrop($event, cellKey, rowKey))
            }, [
              (t != null)
                ? (_openBlock(), _createBlock(TicketCard, {
                    key: 0,
                    onV: ($event: any) => (onCheckClick(t)),
                    onStop: ($event: any) => (onStopClick(t)),
                    onO: ($event: any) => (onResetClick(t)),
                    onX: ($event: any) => (onCloseClick(t)),
                    onClick: ($event: any) => (onClick(t)),
                    onContextmenu: _withModifiers(($event: any) => (onClickRight(t)), ["right"]),
                    onCommand: onCommand,
                    onPerson: (p, index) => onPersonClick(t, p, index),
                    onBlock: _cache[1] || (_cache[1] = (blocker) => onBlockClick(blocker)),
                    onFiles: (f) => onFiles(t, f),
                    level: _ctx.level,
                    "circled-x": _ctx.circledX,
                    controller: props.controller,
                    todo: todoOrUndefined(t),
                    ticket: ticketOrUndefined(t),
                    efforts: _ctx.efforts
                  }, null, 8, ["onV", "onStop", "onO", "onX", "onClick", "onContextmenu", "onPerson", "onFiles", "level", "circled-x", "controller", "todo", "ticket", "efforts"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
            ], 42, _hoisted_2))
          }), 128))
        ])
      ], 64))
    }), 128)),
    (props.focused_index != null && props.focused_index >= props.matrix.length && props.focused != null)
      ? (_openBlock(), _createBlock(TicketSlideup, {
          key: 0,
          model: props.focused,
          files: props.files,
          level: props.level,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('popupClosed')))
        }, null, 8, ["model", "files", "level"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.x4 ? 4 : 5, (i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["cell", { 'cell-x4': props.x4 ?? false, 'cell-x5': !props.x4 ?? true }]),
          onDragenter: _withModifiers(onDrageEnter, ["prevent"]),
          onDragleave: onDragLeave,
          onDragover: onDragOver,
          onDrop: ($event: any) => (onDrop($event, i-1, props.matrix.length))
        }, null, 42, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})